import React from "react";
import { FaInstagram, FaTwitter, FaFacebook, FaYoutube, FaTiktok } from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { themes } from '../../theme.ts';

const InfluencerSocialAccounts: React.FC = () => {
  const { themeName } = useTheme();
  const handleConnect = (platform: string) => {
    // Basic placeholder for connect action
    alert(`Connecting to ${platform}`);
  };

  return (
    <div
      className="min-h-screen p-8"
      style={{ backgroundColor: themes[themeName].colors.background }}
    >
      <div className="max-w-4xl mx-auto">
        <h2
          className="text-3xl font-bold text-center mb-8"
          style={{ color: themes[themeName].colors.text }}
        >
          Connect Your Social Accounts
        </h2>
        <p
          className="text-center mb-8"
          style={{ color: themes[themeName].colors.textSecondary }}
        >
          Link your social media accounts to showcase your influence and reach.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Instagram */}
          <div
            className="p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            style={{
              backgroundColor: themes[themeName].colors.surface,
              borderColor: themes[themeName].colors.border,
              borderWidth: 1,
              borderStyle: 'solid'
            }}
          >
            <div className="flex items-center mb-4">
              <FaInstagram className="text-pink-500 text-3xl mr-3" />
              <h3
                className="text-xl font-semibold"
                style={{ color: themes[themeName].colors.text }}
              >
                Instagram
              </h3>
            </div>
            <button
              onClick={() => handleConnect("Instagram")}
              className="w-full py-2 px-4 rounded-lg transition-colors hover:opacity-90"
              style={{
                backgroundColor: '#a32b59ff',
                color: '#FFFFFF'
              }}
            >
              Connect
            </button>
          </div>

          {/* Facebook */}
          <div
            className="p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            style={{
              backgroundColor: themes[themeName].colors.surface,
              borderColor: themes[themeName].colors.border,
              borderWidth: 1,
              borderStyle: 'solid'
            }}
          >
            <div className="flex items-center mb-4">
              <FaFacebook className="text-blue-600 text-3xl mr-3" />
              <h3
                className="text-xl font-semibold"
                style={{ color: themes[themeName].colors.text }}
              >
                Facebook
              </h3>
            </div>
            <button
              onClick={() => handleConnect("Facebook")}
              className="w-full py-2 px-4 rounded-lg transition-colors hover:opacity-90"
              style={{
                backgroundColor: '#1667d1ff',
                color: '#FFFFFF'
              }}
            >
              Connect
            </button>
          </div>

          {/* YouTube */}
          <div
            className="p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            style={{
              backgroundColor: themes[themeName].colors.surface,
              borderColor: themes[themeName].colors.border,
              borderWidth: 1,
              borderStyle: 'solid'
            }}
          >
            <div className="flex items-center mb-4">
              <FaYoutube className="text-red-500 text-3xl mr-3" />
              <h3
                className="text-xl font-semibold"
                style={{ color: themes[themeName].colors.text }}
              >
                YouTube
              </h3>
            </div>
            <button
              onClick={() => handleConnect("YouTube")}
              className="w-full py-2 px-4 rounded-lg transition-colors hover:opacity-90"
              style={{
                backgroundColor: '#c02929ff',
                color: '#FFFFFF'
              }}
            >
              Connect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfluencerSocialAccounts;
